import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const OCCUPANCY_FEE: AppRouteRecordRaw = {
  path: '/billing/occupancy-rule',
  name: '占位费管理',
  component: DEFAULT_LAYOUT,
  redirect: '/billing/occupancy-rule/index',
  meta: {
    locale: '占位费管理',
    icon: 'icon-file',
    requiresAuth: true,
    roles: ['*'],
    order: 6,
  },
  children: [
    {
      path: 'index',
      name: 'OccupancyFeeRule',
      component: () => import('@/views/billing/occupancy-rule/index.vue'),
      meta: {
        locale: '占位费管理',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
        activeMenu: '占位费管理',
      },
    },
  ],
};

export default OCCUPANCY_FEE;
